<template lang="pug">
  .component-book-panel(:id="id")
    .row.columns
      .callout
        .row
          .columns.small-12.large-6
            label Booking Mode
              BookingModeSelect(v-model="booking_mode", :disabled="hideSearchFields")
          .columns.small-12.large-6(v-if="!driverId")
            label Driver
            SearchEntity(v-model="book.driver_id", entity="drivers" :loadedValues="entityDrivers")

        .row
          .columns.small-12.large-6
            label Vehicle
              selectize-vehicle(@optionSelected="setVehicle", @optionRemoved="unsetVehicle", :disabledSlot="0")
          .columns
            label Driver position
              GoogleMapSearchBox(@placesChanged="setDriverPosition")

        .row
          .columns.small-12.large-6
            label Memo
              input(type="text" v-model="book.memo")
        h2 Extra costs
        .row
          //.column
            label Apply zone extra cost on reservation start
            input(type="checkbox",)
          .column
            label Costs
            selectize-common-cost(:maxItems="null", @optionSelected="addCommonCost", @optionRemoved="removeCommonCost")
        .row(v-if="['RT','CRT','SRT','STR'].includes(booking_mode) && !hideSearchFields")
          .columns
            label Start
              date-picker(v-model="start", :pickTime="true", :initialDate="bookStart", :disabledFrom="disabledFrom", :format="'yyyy-mm-dd hh:ii'")
          .columns
            label End
              date-picker(v-model="end", :pickTime="true", :initialDate="end", :disabledFrom="disabledFrom", :format="'yyyy-mm-dd hh:ii'")
        .row(v-if="!hideSearchFields")
          .columns
            button.button(type="button", v-on:click="dataLoader", :disabled="disabledSearchButton") Search vehicle
        .search-results(v-if="!hideSearchFields")
          loading-spinner(v-if="loading")

          tab-headers(v-else-if="vehicleLength>0" :tabs="['Vehicles Map', 'Vehicles List']", :id="'book-vehicle'", :activeIndex="0")
            tab-content(:headerName="'Vehicles Map'", :active="true")
              book-vehicle-from-map(:vehicles="vehicles", :userPosition="getUserPosition", @getVehicleSelected="bookNow")
            tab-content(:headerName="'Vehicles List'", :active="true")
              .grouped.card(v-for="(slots, key) in slotsByLots" :style="gridStyle(slots)" )
                h1.text-center {{key}}
                vehicle(v-for="(vehicle, id) in slots", :key="id", :item="vehicle", v-if="!vehicle.disabled",  type="search-result", @bookVehicle="bookNow" )
        .availability(v-else)
          .row
            .columns
              label Start
                date-picker(v-model="start", :pickTime="true", :initialDate="start", :disabledFrom="disabledFrom", :format="'yyyy-mm-dd hh:ii'")
            .columns
              label End
                date-picker(v-model="end", :pickTime="true", :initialDate="end", :disabledFrom="disabledFrom", :format="'yyyy-mm-dd hh:ii'")
          .row.columns
            button.button( @click="bookFast" v-if="book.driver_id && !bookDirectlyHide" :disabled="!end") Book

          .row.columns
          backoffice-vehicle-availability(v-if="availability.length && !bookDirectly" , :availability="availability", @slotsSelected="setDatesAndBook" @loadExtra="showExtraDay" @rangeSelection="rangeSelection")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import DatePicker from 'components/structure/DatePicker'
import Reservation from 'components/backoffice/Reservation'
import SelectizeDriver from './lists/selectize/SelectizeDriver'
import Vehicle from 'components/backoffice/Vehicle'
import LoadingSpinner from '../LoadingSpinner'
import SelectizeVehicle from './lists/selectize/SelectizeVehicle'
import BackofficeVehicleAvailability from '../../backoffice/VehicleAvailability'
import collect from 'collect.js'
import BookingModeSelect from '../BookingModeSelect'
import GoogleMapSearchBox from '../../../lib/map/GoogleMapSearchBox'
import SelectizeCommonCost from './lists/selectize/SelectizeCommonCost'
import moment from "moment";
import BookVehicleFromMap from "../../backoffice/BookVehicleFromMap";
import TabHeaders from "../foundation/TabHeaders";
import TabContent from "../foundation/TabContent";
import SearchEntity from "./SearchEntity.vue";

export default {
  name: 'BookPanel',
  components: {
    SearchEntity,
    TabHeaders,
    TabContent,
    BookVehicleFromMap,
    SelectizeCommonCost,
    GoogleMapSearchBox,
    BookingModeSelect,
    BackofficeVehicleAvailability,
    SelectizeVehicle,
    LoadingSpinner,
    Vehicle,
    SelectizeDriver,
    KeplerBackofficeSdk,
    DatePicker,
    Reservation,
  },

  data() {
    return {
      book: {
        plate: null,
        driver_id: null,
        memo: null,
        latitude: null,
        longitude: null,
        common_costs: [],
        skip_apply_zone_cost_start: false
      },
      start: null,
      end: null,
      reservation: null,
      vehicles: [],
      booking_mode: 'RT',
      loading: false,
      hideSearchFields: false,
      availability: [],
      vehicle_id: null,
      bookDirectly: true,
      bookDirectlyHide: false,
      vehicleLength: 0,
    }
  },
  created() {
    this.start = this.bookStart
    this.book.start = this.$convertTimestamp(this.bookStart)
    this.book.end = this.$convertTimestamp(this.bookEnd)
    this.book.driver_id = this.driverId
  },
  methods: {
    addCommonCost(obj) {
      this.book.common_costs.push(obj.id)
    },
    removeCommonCost(obj) {
      this.book.common_costs.find((item, key) => {
        if (item === obj.id) {
          this.book.common_costs.splice(key, 1)
        }
      })
    },
    setDriverPosition(place) {
      this.book.latitude = place.geometry.location.lat()
      this.book.longitude = place.geometry.location.lng()
    },
    setDriverId(driver) {
      this.book.driver_id = driver.id
    },
    setVehicle(object) {
      this.hideSearchFields = true
      this.book.start = this.$convertTimestamp(this.bookStart)
      this.book.end = this.$convertTimestamp(this.bookEnd)
      this.book.plate = object.plate
      this.vehicle_id = object.id
    },
    unsetVehicle() {
      this.book.plate = null
      this.hideSearchFields = false
      this.end = null
      this.availability = []
    },
    searchAvailability(callback = null) {

      KeplerBackofficeSdk.vehicles.select(this.vehicle_id, {
        start: this.$convertTimestamp(this.start),
        end: this.$convertTimestamp(this.end)
      }).availability((data) => {
        data.forEach((a) => {
          Object.assign(a, {selected: false})
        })
        this.availability = data
        this.availability.forEach((item) => {
          if (!item.available) {
            this.bookDirectly = false
            this.bookDirectlyHide = true
          }
        })
        if (callback) callback()
      })
    },
    bookNow(vehicle) {
      this.book.plate = vehicle.plate
      this.sendBooking()
    },
    setDatesAndBook(date) {
      this.book.start = date.start
      this.book.end = date.end
      this.sendBooking()
    },
    sendBooking() {
      KeplerBackofficeSdk.reservations.make(this.book, (response) => {
        this.reservation = response
        this.vehicles = []
        MaggieHelper.notification('book-esit', 'reservation created')
        this.$router.push({name: 'reservation', params: {id: response.id}})
        this.$emit('reservationCreated')
      })
    },
    gridStyle(slots) {
      const auto = slots.length > 3 ? 'auto auto auto' : `repeat(${slots.length},auto)`
      return {
        gridTemplateColumns: auto
      }
    },
    dataLoader() {
      this.loading = true
      if (this.booking_mode === 'RT' || this.booking_mode === 'CRT') {
        this.book.start = this.$convertTimestamp(this.start)
        this.book.end = this.$convertTimestamp(this.end)
      }

      KeplerBackofficeSdk.vehicleSlots.search({
        start: this.book.start,
        end: this.book.end,
        booking_mode: this.booking_mode,
        latitude: this.book.latitude,
        longitude: this.book.longitude,
      }, (data) => {
        this.loading = false
        var vehicles = data.filter((item) => {
          return !item.disabled && !item.dismissed
        }).map((item) => {
          item.vehicle['distance'] = parseFloat(item.distance / 1000).toFixed(2)
          return item.vehicle
        })
        this.vehicles = vehicles
        this.vehicleLength = this.vehicles.length

      })
    },

    showExtraDay() {
      this.end = this.$date(this.end).add(1, 'days').hours(23).minutes(30).seconds(0).format('YYYY-MM-DD HH:mm')
      this.searchAvailability()
    },
    bookFast() {

      this.searchAvailability(() => {
        if (this.bookDirectly) {
          this.setDatesAndBook({start: this.$convertTimestamp(this.start), end: this.$convertTimestamp(this.end)})
        }
      });

    },
    rangeSelection(range) {

      if (range.start != null) {
        this.start = moment.unix(range.start).format('YYYY-MM-DD HH:mm')
      }
      if (range.end != null) {
        this.end = moment.unix(range.end).format('YYYY-MM-DD HH:mm')
      }
    },
  },
  computed: {
    disabledFrom() {
      var date = this.$date()
      date.subtract(1, 'day')
      date.hours(23)
      date.minutes(59)
      return this.$dateFormat(date, 'YYYY-MM-DD HH:mm')
    },
    bookStart() {
      var date = this.$date()
      if (date.minutes() < 30) {
        date.minutes(0)
      } else {
        date.minutes(30)
      }
      return this.$dateFormat(date, 'YYYY-MM-DD HH:mm')
    },
    bookEnd() {
      var date = this.$date(this.start)
      date.minutes(date.minutes() + 30)
      return this.$dateFormat(date, 'YYYY-MM-DD HH:mm')
    },
    disabledSearchButton() {
      var rt = this.booking_mode === 'RT'
      return (rt && !this.start && !this.end) || (!this.book.driver_id)
    },
    bookingDates() {
      return this.booking_mode === 'RT' ? {
        start: this.book.start,
        end: this.book.end,
      } : {
        start: this.$date().unix(),
        end: this.$date().add(7, 'days').unix(),
      }
    },
    slotsByLots() {
      const c = collect(this.vehicles)
      return c.groupBy((item) => {
        return item.parking_lot.name
      }).all()

    },
    getUserPosition() {
      return (this.book.latitude && this.book.longitude) ? {
        latitude: this.book.latitude,
        longitude: this.book.longitude
      } : null
    },

  },
  props: {
    id: {
      required: false,
    },
    entityDrivers: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    driverId: {
      required: false
    }
  },
  watch: {
    booking_mode: {
      handler(bm) {
        if (bm === 'FF') {
          this.end = null
          this.book.end = this.$date().add('2', 'hours').unix()
        }
      },
    },
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-book-panel
  .loading-spinner
    margin: 0 auto

  .grouped
    display: grid
    grid-template-columns: auto auto auto
    @media(max-width: 600px)
      grid-template-columns: auto !important

    h1
      grid-column: 1/-1
</style>



// WEBPACK FOOTER //
// BookPanel.vue?61c869b9